// Roadmap Toolkit - Shared Constants

export const MONTHS = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
] as const;

export const STATUS_COLORS: Record<string, string> = {
    planned: '#94a3b8',      // slate-400
    in_progress: '#3b82f6',  // blue-500
    completed: '#22c55e',    // green-500
    blocked: '#ef4444',      // red-500
    cancelled: '#1f2937',    // gray-800 — clearly darker than planned/slate-400 (audit M6)
    deferred: '#f59e0b',     // amber-500
};

export const PRIORITY_COLORS: Record<string, string> = {
    critical: '#dc2626',  // red-600
    high: '#f97316',      // orange-500
    medium: '#eab308',    // yellow-500
    low: '#22c55e',       // green-500
};

export const METRO_LINE_COLORS = [
    '#ef4444', // red
    '#f97316', // orange
    '#eab308', // yellow
    '#22c55e', // green
    '#14b8a6', // teal
    '#3b82f6', // blue
    '#8b5cf6', // violet
    '#ec4899', // pink
];

export const CANVAS_NODE_STYLES: Record<string, { bg: string; border: string; icon: string }> = {
    vision: { bg: '#f3e8ff', border: '#a855f7', icon: '🎯' },    // purple-100, purple-500
    theme: { bg: '#dbeafe', border: '#3b82f6', icon: '📦' },     // blue-100, blue-500
    step: { bg: '#dcfce7', border: '#22c55e', icon: '👣' },      // green-100, green-500
    support: { bg: '#cffafe', border: '#06b6d4', icon: '💪' },   // cyan-100, cyan-500 — distinct from step/green (audit M5)
    challenge: { bg: '#fee2e2', border: '#ef4444', icon: '⚠️' }, // red-100, red-500
    note: { bg: '#fef9c3', border: '#eab308', icon: '📝' },      // yellow-100, yellow-500
};
